var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{attrs:{"md-flex":"100","md-gutter":""}},[(_vm.consentForm)?_c('consent-form',{staticClass:"hoistAboveOverlay",attrs:{"consentForm":_vm.consentForm,"offering":_vm.offering,"response":_vm.response},on:{"change":_vm.updateUserConsent}}):_vm._e(),_vm._v(" "),(_vm.response === undefined)?_c('div',{staticClass:"overlay"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db9a1c52","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/ConsentFormWrapper.vue
// module id = 895
// module chunks = 0